import { tv } from "@otomoro/helpers/mergeClasses";
import { VariantProps } from "tailwind-variants";

export const styles = tv({
  slots: {
		outerWrapper: 'mt-5 lg:mt-7',
		outerHeader: '[&>h2]:lg:col-span-6 flex flex-col items-center mx-auto text-center w-full mb-2 lg:mb-3',
    base: 'overflow-hidden bg-black',
    wrapper: 'px-2 pt-6 pb-4 lg:pt-7 lg:pb-5 lg:px-4 2xl:max-w-[172rem] 2xl:mx-auto flex flex-col items-center',
    header: 'flex flex-col items-center mx-auto text-center w-full',
    desktopList: 'block lg:absolute lg:top-0 lg:left-0 lg:w-full lg:h-full',
    mobileList: 'w-full mt-4 lg:hidden',
    mapWrapper: 'relative w-[135%] md:w-full mt-4 lg:mt-[8.5rem]',
    marker: 'absolute top-1/2 left-1/2 z-0',
    pin: 'absolute top-1/2 left-1/2 size-[12px] md:size-[15px] -translate-y-1/2 -translate-x-1/2 bg-mainPink rounded-full before:content-[""] before:size-full before:rounded-full before:absolute before:top-0 before:left-0 before:bg-transparent before:border-[0.34px] md:before:border-[1px] before:border-mainPink cursor-pointer before:origine-center before:opacity-0 after:absolute after:top-0 after:left-0 after:size-full after:origin-center after:scale-[200%]',
    slider: 'relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-[50%] after:bg-black bg-lightGrey',
    figure: 'rounded-l overflow-hidden aspect-square md:aspect-[88/48]',
		image: 'h-full w-full object-cover',
		slide: 'max-w-[80vw] md:max-w-[62vw]',
  },
  variants: {
    country: {
      fr: {
        marker: 'top-[39%] left-[49%]',
      },
      nl: {
        marker: 'top-[31%] left-[49.5%] lg:top-[32%] lg:left-[49%]',
      },
      in: {
        marker: 'top-[51%] left-[68.5%]',
      },
      usa: {
        marker: 'top-[38%] left-[20%]',
      },
      be: {
        marker: 'top-[35%] left-[47%] lg:top-[34%] lg:left-[48%]',
      },
    },
    active: {
      true: {
        pin: 'before:animate-pin before:opacity-100',
        marker: 'z-[1]',
      },
    }
  }
})

export type MapVariants = VariantProps<typeof styles>
